export default "__VITE_ASSET__CqIL_k80__"